import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import classes from "./MoobiVault.module.scss"; // SCSS module

function CaroselComponent({ images, arrowsPnPl, length, Bnpl }) {
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState(null);

    const goToNextImage = () => {
        setSelectedImageIndex((prevIndex) => {
            const nextIndex = prevIndex + 1;
            return nextIndex < images.length ? nextIndex : 0;
        });
    };

    const goToPreviousImage = () => {
        setSelectedImageIndex((prevIndex) => {
            const prevIndexVal = prevIndex - 1;
            return prevIndexVal >= 0 ? prevIndexVal : images.length - 1;
        });
    };

    const openModal = (image) => {
        setModalImage(image);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalImage(null);
    };

    useEffect(() => {
        if (isModalOpen) {
            setModalImage(images[selectedImageIndex]);
        }
    }, [selectedImageIndex, isModalOpen, images]);

    const settings = {
        rows: 1,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: length,
        slidesToScroll: length,
        autoplay: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    rows: 1,
                    slidesToShow: length,
                    slidesToScroll: length,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    rows: 1,
                    slidesToShow: length,
                    slidesToScroll: length,
                    infinite: true,
                    dots: false,
                },
            },
        ],
    };

    return (
        <div className={`${Bnpl ? 'containersCaroselLeft' : 'containersCaroselRight'} ${classes.sliderContainer} white-arrows`}>
            <div className={`${classes.backBorder} ${classes[arrowsPnPl]}`}>
                <div className={classes.mainImageContainer}>
                    <img
                        src={`${images[selectedImageIndex]}?v=${selectedImageIndex}`}
                        alt={`Main image ${selectedImageIndex + 1}`}
                        className={classes.mainImage}
                        onClick={() => openModal(images[selectedImageIndex])}
                    />
                </div>
            </div>

            <div className={classes.thumbnailSliderContainer}>
                <div className={classes.arrowWrapper}>
                    <div
                        className={`${classes.arrowStyleCaroselLeft} ${classes[arrowsPnPl]}`}
                        onClick={goToPreviousImage}
                    />
                    <div>
                        <Slider {...settings} className={classes.thumbnailSlider}>
                            {images.map((image, index) => (
                                <div
                                    key={index}
                                    onClick={() => {
                                        setSelectedImageIndex(index);
                                        openModal(image);
                                    }}
                                    className={classes.thumbnailWrapper}
                                >
                                    <img
                                        src={image}
                                        alt={`Thumbnail ${index + 1}`}
                                        className={`${classes.thumbnailImage} ${classes[arrowsPnPl]} ${selectedImageIndex === index ? classes.selected : ""}`}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                    <div
                        className={`${classes.arrowStyleCaroselRight} ${classes[arrowsPnPl]}`}
                        onClick={goToNextImage}
                    />
                </div>
            </div>

            {isModalOpen && (
                <div className={classes.modalOverlay} onClick={closeModal}>
                    <div
                        className={`${classes.arrowStyleCaroselLeftModal} ${classes[arrowsPnPl]}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            goToPreviousImage();
                        }}
                    />
                    <div className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
                        <img src={modalImage} alt="Large view" className={classes.modalImage} />
                        <button className={classes.closeButton} onClick={closeModal}>×</button>
                    </div>
                    <div
                        className={`${classes.arrowStyleCaroselRightModal} ${classes[arrowsPnPl]}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            goToNextImage();
                        }}
                    />
                </div>
            )}
        </div>
    );
}

export default CaroselComponent;
